import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Select, Spin } from "antd";
import dayjs from "dayjs";
import CommonFooter from "../../../../../../core/common/footer/commonFooter";
// import { Edit, Eye } from "feather-icons-react/build/IconComponents";

import Swal from "sweetalert2";
import { BASE_CRM_URL } from "../../../../../components/config/config";
import axios from "axios";
import PropTypes from "prop-types";
import Table from "../../../../../../core/pagination/datatable";


const InvoicesTab = ({ CustomerData }) => {
  const customerId = CustomerData?.customerId;

  const [invoiceStatusOptions, setInvoiceStatusOptions] = useState([]);

  const getInvoiceStatuses = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}invoice/GetInvoiceStatus`);

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.InvoiceStatus,
        }));

        setInvoiceStatusOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      title: "Invoice #",
      dataIndex: "InvoiceNo",

      render: (_, record) => {
        return (
          <Link
            to={`/crm/view/invoice`}
            state={{ record }}
            className="text-decoration-none"
          >
            <span className={`  text-black `}>
              <i className="fa-regular fa-file-lines  me-2"></i>
              {record.InvoiceNo}
            </span>
          </Link>
        );
      },
    },

    {
      title: "Amount",
      dataIndex: "totalAmount",

      render: (_, record) => (
        <>
          <div className="fw-semibold text-success">
            <i className="fa-solid fa-indian-rupee-sign me-2"></i>
            {record.total}
          </div>

          <small className="text-muted">
            <i className="fa-solid fa-percent me-2"></i>
            Tax : {record.total_tax}
          </small>
        </>
      ),
    },

    {
      title: "Invoice Date",
      dataIndex: "date",
      render: (date) => (
        <>
          <div>
            <i className="fa-regular fa-calendar me-2 text-primary"></i>
            {date ? dayjs(date).format("DD/MM/YYYY") : "-"}
          </div>
        </>
      ),
    },

    {
      title: "Due Date",
      dataIndex: "duedate",

      render: (duedate) => {
        if (!duedate) {
          return "-";
        }

        const due = dayjs(duedate);
        const today = dayjs().startOf("day");
        const days = due.startOf("day").diff(today, "day");

        return (
          <>
            <div>
              <i className="fa-regular fa-calendar-check me-2 text-primary"></i>
              {due.format("DD/MM/YYYY")}
            </div>

            <small
              className={
                days < 0
                  ? "text-danger"
                  : days <= 7
                    ? "text-warning"
                    : "text-success"
              }
            >
              <i className="fa-regular fa-clock me-2"></i>

              {days < 0
                ? `${Math.abs(days)} days overdue`
                : days === 0
                  ? "Due today"
                  : `${days} days left`}
            </small>
          </>
        );
      },
    },

    {
      title: "Status",
      dataIndex: "StatusName",

      render: (text, record) => {
        const getColor = (status) => {
          switch (status) {
            case "Draft":
              return "#0d6efd";

            case "Paid":
              return "#198754";

            case "Partially Paid":
              return "#ffc107";

            case "Unpaid":
              return "#0d6efd";

            case "Cancelled":
              return "#dc3545";

            default:
              return "#6c757d";
          }
        };

        return (
          <Select
            value={
              invoiceStatusOptions.find(
                (item) => item.label === (text || "Draft"),
              )?.value
            }
            style={{ width: 100 }}
            options={invoiceStatusOptions}
            onChange={(value) => {
              updateInvoiceStatus(record.id, value);
            }}
            dropdownStyle={{ zIndex: 9999 }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: 10,
                  }}
                ></i>

                {option.data.label}
              </div>
            )}
            labelRender={({ value }) => {
              const status = invoiceStatusOptions.find(
                (x) => x.value === value,
              );

              return (
                <span>
                  <i
                    className="fa-solid fa-circle me-2"
                    style={{
                      color: getColor(status?.label),
                      fontSize: 10,
                    }}
                  ></i>
                  {status?.label}
                </span>
              );
            }}
          />
        );
      },
    },

    {
      title: "Action",
      dataIndex: "action",

      render: (_, record) => (
        <>
          {/* <Link className="action-set" to="#" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v btn border"></i>
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                to={`/crm/view/invoice`}
                state={{ record }}
                className="dropdown-item"
              >
                <Eye className="me-2 text-info" />
                View
              </Link>
            </li>

            <li></li>
          </ul> */}
          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                to={`/crm/update/invoice/${record.id}`}
                className="me-2 p-2  shadow-sm"
                // state={{
                //   Id: record.id,
                //   record,
                //   type: "customer",
                // }}
              >
             <i className="ti ti-pencil text-primary"></i>
               
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];
  const invoiceStatusCards = [
    {
      id: 1,
      name: "Draft",
      textClass: "text-info",
      bgClass: "bg-info",
      icon: "fa-file-pen",
    },
    {
      id: 2,
      name: "Paid",
      textClass: "text-success",
      bgClass: "bg-success",
      icon: "fa-circle-check",
    },
    {
      id: 3,
      name: "Unpaid",
      textClass: "text-danger",
      bgClass: "bg-danger",
      icon: "fa-file-invoice-dollar",
    },
    {
      id: 4,
      name: "Partially Paid",
      textClass: "text-warning",
      bgClass: "bg-warning",
      icon: "fa-money-bill-transfer",
    },
    {
      id: 5,
      name: "Cancelled",
      textClass: "text-dark",
      bgClass: "bg-dark",
      icon: "fa-triangle-exclamation",
    },
  ];

  const [invoiceCounts, setInvoiceCounts] = useState([]);

  const [invoice, setInvoice] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(0);
  // const [countLoading, setCountLoading] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(false);

  console.log(invoiceCounts, invoice, invoiceLoading);

  const fetchInvoiceCounts = async () => {
    try {
      const response = await axios.get(
        `${BASE_CRM_URL}invoice/GetInvoiceCountsByCustId`,
        {
          params: {
            clientid: customerId,
          },
        },
      );

      if (response.data?.Status) {
        setInvoiceCounts(response.data.ResultData || []);
      } else {
        setInvoiceCounts([]);
      }
    } catch (error) {
      console.error("Error fetching invoice counts:", error);
      setInvoiceCounts([]);
    }
  };

  const fetchInvoice = async (status = 0) => {
    try {
      setInvoiceLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}invoice/GetInvoicesByCustId`,
        {
          params: {
            Status: status,
            clientid: customerId,
          },
        },
      );

      if (response.data?.Status) {
        setInvoice(response.data.ResultData || []);
      } else {
        setInvoice([]);
      }
    } catch (error) {
      console.error("Get Estimates Error:", error);
      setInvoice([]);
    } finally {
      setInvoiceLoading(false);
    }
  };

  const updateInvoiceStatus = async (InvoiceId, statusId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}invoice/UpdateInvoiceStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: InvoiceId,
            status: statusId,
          }),
        },
      );

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1200,
          showConfirmButton: false,
        });

        fetchInvoice(0); // Reload your proposal list
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchInvoiceCounts();
    fetchInvoice(0);
    getInvoiceStatuses();
  }, []);


  return (
    <>
      <div>
        <div className="row g-3">
          {invoiceStatusCards.map((card) => {
            const status = invoiceCounts.find(
              (item) => item.StatusId === card.id,
            );

            const count = status?.Count || 0;
            const total = status?.TotalCount || 0;

            return (
              <div className="col-12 col-sm-6 col-xl d-flex" key={card.id}>
                <div
                  className={`card flex-fill shadow-sm ${
                    selectedStatus === card.id ? "border-primary" : ""
                  }`}
                  onClick={() => {
                    setSelectedStatus(card.id);
                    fetchInvoice(card.id);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <div className="card-body d-flex justify-content-between align-items-center  py-2 px-3">
                    <div className="d-flex align-items-center gap-2 text-nowrap">
                      <h4 className="mb-0 fw-bold">
                        {count}/{total}
                      </h4>

                      <p className={`mb-0  fw-semibold`}>{card.name}</p>
                    </div>

                    <div
                      className={`rounded-circle ${card.bgClass} bg-opacity-10 d-flex align-items-center justify-content-center`}
                      style={{
                        width: 40,
                        height: 40,
                      }}
                    >
                      <i
                        className={`fa-solid ${card.icon} ${card.textClass} fs-4`}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="card table-list-card ">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set">
         
            </div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="page-btn">
                {/* <Link
                  to="#"
                  className="btn btn-soft-info btn-sm d-inline-flex align-items-center"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasZipInvoice"
                >
                  <span>Zip Invoice</span>
                </Link> */}
                <Link
                  to="/crm/add/invoice"
                  className="btn btn-success btn-sm me-2"
                  state={{
                    type: "customer",
                    customerId: CustomerData.customerId,
                    record: CustomerData,
                  }}
                  // state={{
                  //   type: "customer",
                  //   customerId: customerData.customerId,
                  //   record: customerData,
                  // }}
                >
                  <i className="ti ti-circle-plus fs-4 "> </i>
                </Link>
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className=" table-responsive">
                 {invoiceLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "250px", // adjust height if needed
                    }}
                  >
                    <Spin size="large" />
                  </div>
                ) : (
                  <Table columns={columns} dataSource={invoice} />
                )}
            </div>
          </div>
        </div>

        <CommonFooter />
      </div>

      <style>
        {`
@media (max-width: 576px) {
  #offcanvasZipInvoice {
    width: 90% !important;
  }
}

@media (min-width: 577px) and (max-width: 992px) {
  #offcanvasZipInvoice {
    width: 60% !important;
  }
}

@media (min-width: 993px) and (max-width: 1440px) {
  #offcanvasZipInvoice {
    width: 30% !important;
  }
}
  
@media (min-width: 1441px)  {
  #offcanvasZipInvoice {
    width: 23% !important;
  }
}







`}
      </style>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasZipInvoice"
        aria-labelledby="offcanvasZipInvoice"
      >
        <div className="offcanvas-header pb-0">
          <h4>Zip Invoices</h4>

          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <hr />

        <div className="offcanvas-body pt-0">
          <form>
            {/* Status */}
            <div className="mb-3">
              <label className="form-label fw-semibold">Status</label>

              <select className="form-select">
                <option value="">All</option>
                <option value="Unpaid">Unpaid</option>
                <option value="Paid">Paid</option>
                <option value="Partially Paid">Partially Paid</option>
                <option value="Overdue">Overdue</option>
                <option value="Cancelled">Cancelled</option>
                <option value="Draft">Draft</option>
              </select>
            </div>

            {/* From Date */}
            <div className="mb-3">
              <label className="form-label fw-semibold">From Date</label>

              <input type="date" className="form-control" />
            </div>

            {/* To Date */}
            <div className="mb-4">
              <label className="form-label fw-semibold">To Date</label>

              <input type="date" className="form-control" />
            </div>

            {/* Buttons */}
            <div className="d-flex justify-content-end">
              <button type="reset" className="btn btn-light me-2">
                close
              </button>

              <button type="button" className="btn btn-primary">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

InvoicesTab.propTypes = {
  CustomerData: PropTypes.object,
};
export default InvoicesTab;
